'use strict';

const formValidation = require('../components/formValidation');

const createErrorNotification = require('../components/errorNotification');

const loginUtils = require('../utils/loginUtils');

const processInclude = require('base/util');
const capphone = require('capency/capency/phone/formUtils');
const capaddress = require('capency/capency/address/formUtils');
const capencyHelper = require('capency/capencyHelper');
const capencyVerfiyAddress = require('capency/capency/address/capency.verify');
const iscapPhoneEnable = capencyHelper.isCapencyEnabled('phone');
const iscapAddressEnable = capencyHelper.isCapencyEnabled('address');
const notifUtils = require('../utils/notificationUtils');
const clientSideValidation = require('../components/clientSideValidation');
let accountRegistrationUtils = require('../account/accountRegistrationUtils');
let { initCheckboxes } = require('../profile/accountPreferences');
let { initPasswordPattern } = require('./passwordPattern');
/**
 * handler on session expired
 */
function onSessionExpired() {
    window.location.reload();
}
/**
 * Fetches a template from the given URL and replaces the content of the login form container.
 * @param {string} url URL of the template
 * @param {Function} onSuccess Callback function to execute after the template is successfully fetched.
 * @returns {void}
 */
function fetchTemplate(url, onSuccess) {
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'text', // Expecting HTML/text
        success: function (response) {
            document.getElementById('login-form-container').innerHTML = response;
            if (onSuccess) onSuccess();
        },
        error: function (xhr) {
            try {
                const json = JSON.parse(xhr.responseText);
                if (json && json.sessionExpired) {
                    onSessionExpired();
                }
            } catch (e) {
                console.error('There was a problem fetching the template:', e);
            }
        }
    });
}

/**
 * Initializes Capency phone and address functionalities if they are enabled.
 */
function initCapency() {
    if (iscapPhoneEnable === true) {
        capphone.initCapPhoneByForms();
    }
    if (iscapAddressEnable === true) {
        capaddress.initCapAddressByForms();
    }
}

/**
 * Focuses on the first invalid input field in a form based on the provided payload.
 * @param {Object} formElement - The form element to search for invalid fields.
 * @param  {Object} payload - The payload containing field validation information.
 */
function focusOnFirstInput(formElement, payload) {
    if (typeof payload === 'object' && payload.fields) {
        let fieldKeys = Object.keys(payload.fields);
        if (fieldKeys.length > 0 && fieldKeys[0]) {
            // focus on the first invalid field
            let firstInvalidField = $(formElement).find('[name="' + fieldKeys[0] + '"]');
            if (firstInvalidField.length > 0) {
                firstInvalidField.focus();
            }
        }
    }
}
/**
 * Attaches a submit event handler to a form specified by the given configuration.
 * The handler prevents the default form submission, triggers specified events,
 * and performs an AJAX request to submit the form data.
 *
 * @param {Object} config - Configuration object for the form submission.
 * @param {string} config.node - The form element to attach the submit event handler to.
 * @param {Array<string>} config.eventsToTriggerBefore - Array of event names to trigger before the AJAX request.ex: 'login:submit'
 * @param {Array<string>} config.eventsToTriggerOnSuccess - Array of event names to trigger on successful AJAX response. 'login:success'
 * @param {Array<string>} config.eventsToTriggerOnError - Array of event names to trigger on AJAX error. 'login:submit'
 * @param {Function} config.onSuccess - Callback function to execute on successful AJAX response.
 * @param {Function} config.onError - Callback function to execute on AJAX error.
 */
const submitForm = function (config) {
    $(config.node).submit(function (e) {
        let form = $(config.node);
        e.preventDefault();
        let url = form.attr('action');
        form.spinner().start();

        config.eventsToTriggerBefore.forEach((event) => {
            form.trigger(event, e);
        });

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (response) {
                form.spinner().stop();
                config.eventsToTriggerOnSuccess.forEach((event) => {
                    form.trigger(event, response);
                });
                config.onSuccess(form, response);
            },
            error: function (err) {
                form.spinner().stop();
                config.eventsToTriggerOnError.forEach((event) => {
                    form.trigger(event, err);
                });
                if (err.responseJSON.csrfError) {
                    createErrorNotification($('.error-messaging'), $('#login-form-container').data('csrf-error'));
                    setTimeout(() => window.location.reload(), 5000);
                    return;
                }
                config.onError(form, err);
            }
        });
        return false;
    });
};

/**
 * Processes the identification form submission.
 * It attaches a submit event handler to the form, which triggers specified events
 * and performs an AJAX request to submit the form data.
 * On success, it fetches a new template.
 * On error, it handles the error response and displays an error message.
 * @param {Element} node - The form element to attach the submit event handler to.
 * @returns {void}
 * */
function processIdentification(node) {
    submitForm({
        node: node,
        eventsToTriggerBefore: [],
        eventsToTriggerOnSuccess: [],
        eventsToTriggerOnError: [],
        onSuccess: function (form, response) {
            fetchTemplate(response.formUrl);
        },
        onError: function (form, err) {
            const responseJSON = err.responseJSON;
            if (responseJSON) {
                if (responseJSON.sessionExpired) {
                    onSessionExpired();
                }

                const $emailSelector = form.find('#email');

                if (responseJSON.sMessage || responseJSON.errorMessage) {
                    createErrorNotification($('.error-messaging'), responseJSON.sMessage || responseJSON.errorMessage);
                }

                $emailSelector.addClass('is-invalid');
                $emailSelector.toggleClass('autocomplete-field-selected', false);
                $emailSelector.focus();

                if (responseJSON.returnCode === 2) {
                    $emailSelector.autocomplete({
                        create: function () {
                            $(this).attr('autocomplete', 'off');
                        },
                        minLength: 0,
                        autoFocus: true,
                        source: function (request, response) {
                            response(responseJSON.mail.map((item) => ({ label: item.sMail, value: item.sMail })));
                        },
                        select: function (event, ui) {
                            let $this = $(this);
                            $this.next().html(ui.item.sMail);
                            $this.toggleClass('autocomplete-field-selected', true);
                            $this.data('isModified', true);
                        },
                        appendTo: '#' + form.attr('id')
                    }).focus(function () {
                        return false;
                    });
                    $emailSelector.autocomplete('search', '');
                }
            }
        }
    });
}

/**
 *
 * @param {Element} node node
 */
function processPasswordValidation(node) {
    submitForm({
        node: node,
        eventsToTriggerBefore: ['login:submit'],
        eventsToTriggerOnSuccess: ['login:success'],
        eventsToTriggerOnError: ['login:error'],
        onSuccess: function (form, response) {
            if (response.action === 'CheckoutServices-LoginCustomer') {
                if (response.customerLoginResult.status == 'AUTH_OK') {
                    form.trigger('login:success', response);
                    window.location.href = response.redirectUrl;
                } else {
                    formValidation(form, response);
                    form.trigger('login:error', response);
                }
            } else {
                window.location.href = response.redirectUrl;
            }
        },
        onError: function (form, err) {
            const responseJSON = err.responseJSON;
            if (responseJSON) {
                if (responseJSON.sessionExpired) {
                    onSessionExpired();
                }
                loginUtils.handleErrorResponse(responseJSON);
            }
        }
    });
}

/**
 *
 * @param {Element} node node
 */
function processPasswordCreation(node) {
    submitForm({
        node: node,
        eventsToTriggerBefore: [],
        eventsToTriggerOnSuccess: [],
        eventsToTriggerOnError: [],
        onSuccess: function (form, response) {
            fetchTemplate(response.formUrl, () => {
                initCapency();
            });
        },
        onError: function (form, err) {
            const responseJSON = err.responseJSON;
            if (responseJSON) {
                if (responseJSON.sessionExpired) {
                    onSessionExpired();
                }
                if (responseJSON.errorMessage) {
                    createErrorNotification($('.error-messaging'), responseJSON.errorMessage);
                }
                if (responseJSON.error && responseJSON.error.length > 0) {
                    responseJSON.error.forEach((error) => {
                        createErrorNotification($('.error-messaging'), error);
                    });
                }
            }
        }
    });
}
/**
 * Binds the click event to the edit email button.
 */
function initEditEMailButton() {
    const $returnMailButton = $('.return-email');
    if ($returnMailButton.length > 0) {
        $returnMailButton.on('click', function (e) {
            e.preventDefault();
            window.location.reload();
        });
    }
}

/**
 *
 * @param {Element} node node
 */
function processProfileCreation(node) {
    processInclude(clientSideValidation);
    initPasswordPattern();
    initCheckboxes();
    accountRegistrationUtils.helpers.handleCountrySelection();
    accountRegistrationUtils.helpers.submitValidation(() => {
        $('.submit-customer-register').attr('disabled', true);
        let form = $(node);
        let url = form.attr('action');

        const $phoneField = form.find("[name='dwfrm_profile_customer_phone']");
        let fieldValue = $phoneField.val();
        let serializedData = form.serialize();
        let combinedData = serializedData.replace(/(dwfrm_profile_customer_phone=)[^&]+/, '$1' + encodeURIComponent(fieldValue));
        $.ajax({
            url: url,
            method: 'POST',
            data: combinedData,
            success: function (data) {
                $('.submit-customer-register').attr('disabled', false);
                $.spinner().stop();
                const isSuccess = !data.error || data.success;
                if (isSuccess && data.redirectUrl) {
                    form.trigger('login:register:success', data);
                    $('body').trigger('newsletter:subscription', data);
                    window.location.href = data.redirectUrl;
                } else if (data.hasError) {
                    if (data.fields) {
                        const errorFields = Object.keys(data.fields);
                        const addressFields = ['address1', 'address2', 'city', 'postalCode'];
                        if (addressFields.some(field => errorFields.includes(`dwfrm_address_${field}`))) {
                            capencyVerfiyAddress.invalidateRegisteredAddress();
                        }
                    }
                    form.trigger('login:register:error', data);
                    formValidation(form, data);
                    focusOnFirstInput(form, data);
                }
            },
            error: function (err) {
                $('.submit-customer-register').attr('disabled', false);
                $.spinner().stop();
                const responseJSON = err.responseJSON || JSON.parse(err.responseText);
                if (responseJSON) {
                    if (responseJSON.sessionExpired) {
                        onSessionExpired();
                    }

                    if (responseJSON.emailSessionExpired) {
                        setTimeout(() => {
                            window.location.reload();
                        }, '5000');
                    }
                    let message = responseJSON.message || responseJSON.errorMessage;
                    if (message) {
                        notifUtils.send(message, responseJSON.status);
                    }
                }
            }
        });
    });
}

/**
 *
 * @param {Element} node node
 */
function validateOtp(node) {
    const inputs = $('.otp-input');
    submitForm({
        node: node,
        eventsToTriggerBefore: [],
        eventsToTriggerOnSuccess: [],
        eventsToTriggerOnError: [],
        onSuccess: function (form, response) {
            inputs.removeClass('is-invalid').addClass('is-valid');
            fetchTemplate(response.formUrl);
        },
        onError: function (form, err) {
            const responseJSON = err.responseJSON;
            if (responseJSON) {
                if (responseJSON.sessionExpired) {
                    onSessionExpired();
                }
                if (responseJSON.errorMessage) {
                    createErrorNotification($('.error-messaging'), responseJSON.errorMessage);
                }
            }
            inputs.addClass('is-invalid');
        }
    });
}

/**
 * Prevents non-digit characters from being entered in OTP input fields.
 */
function preventNonDigits() {
    $('.otp-input').on('input', function () {
        this.value = this.value.replace(/\D/g, '');
    });
}

/**
 * Launches a timeout for the resend button.
 * @param {Element} btn resend button element
 */
function launchTimeout(btn) {
    const timeout = setTimeout(() => {
        btn.classList.add('active');
        clearTimeout(timeout);
    }, 60000); // 60 seconds
}

/**
 * Handles the OTP resend button click event.
 */
function handleOtpResend() {
    const resendButton = document.getElementById('otp-resend');
    launchTimeout(resendButton);

    resendButton.addEventListener('click', function () {
        resendButton.classList.remove('active');
        launchTimeout(resendButton);
        $.ajax({
            url: this.dataset.url,
            method: 'POST'
        });
    });
}

module.exports = {
    loginFormProcess: function () {
        const container = document.getElementById('login-form-container');
        if (!container) {
            return;
        }
        processIdentification(document.getElementById('dwfrm_login_identification'));
        const steps = ['dwfrm_login_passwordValidation', 'dwfrm_login_passwordCreation', 'dwfrm_profile', 'dwfrm_otp'];

        const observer = new MutationObserver((mutationsList) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (steps.indexOf(node.id) === -1) {
                            return;
                        }
                        initEditEMailButton();
                        switch (node.id) {
                            case 'dwfrm_login_passwordValidation':
                                processPasswordValidation(node);
                                break;
                            case 'dwfrm_login_passwordCreation':
                                processPasswordCreation(node);
                                initPasswordPattern();
                                break;
                            case 'dwfrm_profile':
                                processProfileCreation(node);
                                break;
                            case 'dwfrm_otp':
                                preventNonDigits();
                                handleOtpResend();
                                validateOtp(node);
                                break;
                            default:
                                console.log('Unknown form detected');
                        }
                    });
                }
            }
        });
        observer.observe(container, { childList: true, subtree: true });
    },
    resetPassword: function () {
        $('body').on('submit', '.reset-password-form', function (e) {
            let form = $(this);
            e.preventDefault();
            let url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block">'
                                    + data.buttonText + '</a>');
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('body').on('hidden.bs.modal', '#login .modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    }
};
